import axiosInstance from '../main/axios';
import { showTabs, selectTab } from '../common/tab/tabActions'
import { PAGE_SIZE } from '../common/utils/pageSize';

export function getList(page, sorted, filtered) {
    const request = axiosInstance.get(`/logs/`, { 
        params: {
            page,
            perPage: PAGE_SIZE,
            sort: sorted,
            filter: filtered
        }
    });

    return {
        type: 'USER_LOG_FETCHED',
        payload: request
    }
}

export function getImageById(id) {
    const request = axiosInstance.get(`/logs/image/${id}`);

    return {
        type: 'USER_LOG_IMAGE_FETCHED',
        payload: request
    }
}

export function init() {
    return [
        showTabs('tabList'),
        selectTab('tabList'),
        getList(0)
    ]
}
